import { Lightbulb } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgLightBulb = mkIcon(Lightbulb);